import { Fragment, useCallback, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSetPageActionContext } from 'src/shared/layout/page-layout/page-layout.context-provider';
import DownloadIcon from '@mui/icons-material/Download';
import { Snackbar } from 'src/shared/snackbar/snackbar';
import { Button } from 'src/shared/button/button';
import { useGetInvoicePdfMutation } from '@service/invoice-v1.service';

export function InvoicePreview(): React.JSX.Element {
  const { invoiceId } = useParams();
  const { t } = useTranslation();
  const [error, setError] = useState();
  const [getInvoicePdf] = useGetInvoicePdfMutation();

  const setPageAction = useSetPageActionContext();

  // HANDLERS //////////////////////////////////////////////////////////////////
  const handleDownloadInvoice = useCallback(async () => {
    if (!invoiceId) {
      return;
    }

    try {
      const data = await getInvoicePdf(invoiceId).unwrap();

      const url = URL.createObjectURL(data);

      const a = document.createElement('a');
      a.href = url;
      a.download = `${invoiceId}.pdf`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      URL.revokeObjectURL(url);
    } catch (err: any) {
      setError(err);
    }
  }, [invoiceId, getInvoicePdf]);

  // RENDER ////////////////////////////////////////////////////////////////////

  useLayoutEffect(() => {
    if (!invoiceId) {
      return;
    }

    const downloadInvoiceButton = (
      <Fragment key="download-invoice">
        <Button onClick={handleDownloadInvoice} variant="contained">
          <DownloadIcon />
          {t('invoice-v1.preview.download-button')}
        </Button>

        {!!error && (
          <Snackbar
            variant="error"
            message={t('error.download-invoice-v1-pdf-mutation', {
              error,
            })}
          />
        )}
      </Fragment>
    );

    setPageAction([downloadInvoiceButton]);
  }, [t, invoiceId, setPageAction, error, handleDownloadInvoice]);

  return <div />;

  // const { data: invoiceHtml, isError: isGetInvoiceHtmlError } =
  //   useGetInvoiceHtmlQuery(invoiceId ?? null, {
  //     skip: !invoiceId,
  //   });
  //
  // if (!invoiceHtml) {
  //   return (
  //     <>
  //       <InvoicePlaceholder isError={isGetInvoiceHtmlError} />
  //       {isGetInvoiceHtmlError && (
  //         <Snackbar
  //           variant="error"
  //           message={t('error.get-invoice-v1-html-query')}
  //         />
  //       )}
  //     </>
  //   );
  // }

  // return (
  //   <iframe
  //     srcDoc={invoiceHtml}
  //     title={t('invoice-v1.preview.title')}
  //     style={{
  //       border: 'none',
  //       width: '100%',
  //       height: 'calc(100% - 72px)',
  //     }}
  //   />
  // );
}
